/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Head from 'next/head';
import PartiuGpHeader from '@/components/organisms/PartiuGpHeader';
import PartiuGpHero from '@/components/organisms/PartiuGpHero';
import PartiuGpComoParticipar from '@/components/organisms/PartiuGpComoParticipar';
import PartiuGpPremio from '@/components/organisms/PartiuGpPremio';
import PartiuGpChances from '@/components/organisms/PartiuGpChances';
import PartiuGpCalendario from '@/components/organisms/PartiuGpCalendario';
import PartiuGpSimule from '@/components/organisms/PartiuGpSimule';
import PartiuGpNumerosDaSorte from '@/components/organisms/PartiuGpNumerosDaSorte';
import PartiuGpGanhador from '@/components/organisms/PartiuGpGanhador';
import PartiuGpRegulamento from '@/components/organisms/PartiuGpRegulamento';
import PartiuGpFaq from '@/components/organisms/PartiuGpFaq';
import EmDiaValeMaisFooter from '@/components/organisms/EmDiaValeMaisFooter';
import Styles from './PartiuGpInglaterra.css';

function PartiuGpInglaterra() {
  return (
    <>
      <Head>
        <title>Promoção Partiu GP da Inglaterra | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Financie seu carro ou moto com o Santander e concorra a uma viagem para o GP da Inglaterra 2027, em Silverstone. Confira as regras e participe!"
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/partiugpdainglaterra.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta
          property="og:title"
          content="Promoção Partiu GP da Inglaterra | Santander Financiamentos"
        />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/partiugpdainglaterra.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />;
        <meta
          property="og:description"
          content="Financie seu carro ou moto com o Santander e concorra a uma viagem para o GP da Inglaterra 2027, em Silverstone. Confira as regras e participe!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/partiu-gp-da-inglaterra/hero/foto-desktop.jpg"
        />
        <meta
          property="og:image:alt"
          content="Carro de Fórmula 1 da Santander na pista, com torcida ao fundo."
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta
          name="twitter:title"
          content="Promoção Partiu GP da Inglaterra | Santander Financiamentos"
        />
        <meta
          name="twitter:description"
          content="Financie seu carro ou moto com o Santander e concorra a uma viagem para o GP da Inglaterra 2027, em Silverstone. Confira as regras e participe!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/partiugpdainglaterra.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/partiu-gp-da-inglaterra/hero/foto-desktop.jpg"
        />
        <meta
          property="twitter:image:alt"
          content="Carro de Fórmula 1 da Santander na pista, com torcida ao fundo."
        />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>

      <PartiuGpHeader />

      <PartiuGpHero />

      <PartiuGpComoParticipar />

      <PartiuGpPremio />

      <PartiuGpChances />

      <PartiuGpCalendario />

      <PartiuGpSimule />

      <PartiuGpNumerosDaSorte />

      <PartiuGpGanhador />

      <PartiuGpRegulamento />

      <PartiuGpFaq />

      <EmDiaValeMaisFooter />

      <style jsx>{Styles}</style>
    </>
  );
}

export default PartiuGpInglaterra;
